export default function translate(i18n, propriete) {
  let libellePropriete = propriete;
  if (propriete.indexOf('lignesCommande') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Libelle') {
      return {
        message: 'validationCommande.name.libelleLigneCommande',
      };
    }
    if (libellePropriete === 'Quantite') {
      return i18n.t('validationCommande.name.quantiteLigneCommande');
    }
    if (libellePropriete === 'PrixUnitaire') {
      return i18n.t('validationCommande.name.prixUnitaireLigneCommande');
    }
    if (libellePropriete === 'Remise') {
      return i18n.t('validationCommande.name.remiseLigneCommande');
    }
    if (libellePropriete === 'TauxTva') {
      return {
        message: 'validationCommande.name.tauxTvaLigneCommande',
      };
    }

    if (libellePropriete.indexOf('LignesCommande') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'Quantite') {
        return i18n.t('validationCommande.name.quantiteLigneCommande');
      }
      if (libellePropriete === 'PrixUnitaire') {
        return i18n.t('validationCommande.name.prixUnitaireLigneCommande');
      }
      if (libellePropriete === 'Remise') {
        return i18n.t('validationCommande.name.remiseLigneCommande');
      }
    }
    if (libellePropriete.indexOf('LigneCommandeDispositif') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'NomDispositif') {
        return i18n.t('validationCommande.name.nomDispositif');
      }
      if (libellePropriete === 'MaterielTypeId') {
        return i18n.t('validationCommande.name.materielTypeId');
      }
      if (libellePropriete === 'DispositifTypeId') {
        return i18n.t('validationCommande.name.dispositifTypeId');
      }
      if (libellePropriete === 'MaterielFormatId') {
        return i18n.t('validationCommande.name.materielFormatId');
      }
    }

    if (libellePropriete.indexOf('LignesRemise') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'Remise') {
        return i18n.t('validationCommande.name.remise');
      }
    }

    if (libellePropriete.indexOf('LieuxLivraisons') === 0) {
      if (libellePropriete.endsWith('Quantite')) {
        return i18n.t('addEditCommande.lieuLivraison.errors.quantite');
      }
      if (libellePropriete.endsWith('LieuDeLivraisonId')) {
        return i18n.t('addEditCommande.lieuLivraison.errors.lieuLivraison');
      }
    }
    return libellePropriete;
  }

  if (libellePropriete.indexOf('commissions') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'PourcentageRepartition') {
      return i18n.t('validationCommande.name.pourcentageRepartition');
    }
  }

  if (propriete.indexOf('intervenant') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Repartition') {
      return i18n.t('validationDevis.name.repartitionIntervenant');
    }
  }
  if (propriete === 'dateDevisCommande') {
    return {
      message: 'validationCommande.name.dateDevisCommande',
    };
  }

  if (propriete === 'dateValidite') {
    return {
      message: 'validationCommande.name.dateValidite',
    };
  }
  if (propriete === 'motifNonRenouvellement') {
    return i18n.t('validationCommande.name.motifNonRenouvellement');
  }

  if (propriete.indexOf('echeanciers') !== -1) {
    libellePropriete = libellePropriete.slice(libellePropriete.lastIndexOf('.') + 1);
    if (libellePropriete === 'dateDebut') {
      return 'echeancierFacturation.messages.errors.required.dateDebutEcheance';
    }
    if (libellePropriete === 'dateFin') {
      return 'echeancierFacturation.messages.errors.required.dateFinEcheance';
    }
    if (libellePropriete === 'datePrevisionnelleFacturation') {
      return 'echeancierFacturation.messages.errors.required.dateFinPremiereEcheance';
    }
    if (libellePropriete === 'tiersId') {
      return 'echeancierFacturation.messages.errors.required.payeur';
    }
    if (libellePropriete === 'montant') {
      return 'echeancierFacturation.messages.errors.required.montant';
    }
    if (libellePropriete === 'CommentaireFacturation') {
      return i18n.t('echeancierFacturation.messages.errors.required.commentaireFacturation');
    }
  }

  if (propriete.indexOf('etatSuivis') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.lastIndexOf('.') + 1);
    if (libellePropriete === 'etatSuiviId') return i18n.t('validationCommande.name.etatSuiviId');
  }
  if (propriete === 'assistantId') {
    return i18n.t('validationCommande.name.assistant');
  }
  if (propriete === 'commercialId') {
    return i18n.t('validationCommande.name.commercial');
  }

  if (propriete.endsWith('EtatSuiviId')) {
    const regex = /[\d+)]/;
    const result = propriete.match(regex);
    if (result) {
      return i18n.t('validationCommande.etatDeSuivi', { ligne: parseInt(result, 10) + 1 });
    }
  }
  // gestion des erreurs de champs qui vienne de la création d'une demande l'intervention
  if (propriete === 'demandeurId') {
    return i18n.t('validationCommande.name.demandeInterventionDemandeur');
  }

  if (propriete === 'typeOtId') {
    return i18n.t('validationCommande.name.typeOt');
  }

  return propriete;
}
